var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-credits"},[_c('a',{attrs:{"target":"_blank","href":"https://thevisualagency.com/"}},[_vm._v("The Visual Agency")])])}]

export { render, staticRenderFns }